import { ApolloClient, gql, useApolloClient, useLazyQuery } from '@apollo/client';
import { InsightsResponse } from '../Constants/insightTypes';

export interface GetInsightsVars {
    entityType: String;
    entityValue: String;
    startTime: number;
    endTime: number;
}

const GET_INSIGHTS = gql`
    query GetInsights(
            $entityType: String,
            $entityValue: String,
            $startTime: Float,
            $endTime: Float,
        ){
        getInsights(
            entityType: $entityType,
            entityValue: $entityValue,
            startTime: $startTime,
            endTime: $endTime,
        )
    }
`;

export const useGetInsightsQuery = () => {
    return useLazyQuery<InsightsResponse, GetInsightsVars>(GET_INSIGHTS, {
        errorPolicy: 'all',
        fetchPolicy: 'network-only'
    });
};

export async function fetchDomainInsights(
  client: ApolloClient<object>,
  domainIdent: string,
  dateRange,
): Promise<InsightsResponse> {
  const { data } = await client.query<any, GetInsightsVars>({
    query: GET_INSIGHTS,
    variables: {
      entityType: 'DOMAINIDENT',
      entityValue: domainIdent,
      startTime: dateRange.from,
      endTime: dateRange.to
    },
    fetchPolicy: 'network-only',
  });
  return data?.getInsights?.record?.insights || [];
}